import React, { useEffect } from "react";
import { useArrayContext } from "../../../state/ArrayContext";
import { useStoredItem } from "../../../state/InternalContext";
import { SourceItem } from "../../../shared/models/source-item.model";

interface ItemPropertyNamesProps {
    item: string,
    category: string,
}

/***
 * Array source that returns the property names of a stored item.
 * 
 * Params:
 *      item: The name of the stored item
 *      category: The category of the property
 */
export const ItemPropertyNames = React.memo(function ItemPropertyNames({ item, category }: ItemPropertyNamesProps): React.ReactElement {
    const { setArray } = useArrayContext();
    const storedItem = useStoredItem(item);

    useEffect(() => {
        const props = storedItem?.props?.[category];
        const result: Array<SourceItem> = props ? Object.keys(props).map((key, ix) => ({
            value: key,
            props: {},
            position: ix + 1,
        })) : [];
        setArray(result);
    }, [storedItem, category, setArray]);

    return <></>;
});